import PublicPolicyPage from '../components/layout/PublicPolicyPage';

export default function PrivacyPolicyPage() {
  return <PublicPolicyPage pageKey="privacy" canonicalPath="/privacy-policy" />;
}
